<template>
    <button type="button" :class="classes">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "AlphaBackgroundButton",
    props: {
        color: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'sm'
        },
        icon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            let classes = ['btn', 'btn-outline', `btn-${this.size}`, `alpha-${this.color}`, `text-${this.color}-800`];
            if (this.icon) {
                classes.push('btn-icon');
            }
            return classes;
        }
    },
}
</script>